import { EnterProductNames, HomePagesRoutes, ProductMatchIndex } from '../Routes';
import { ICONS } from './navIcons';

export const productApprovalOperatorNavConfig = [
  {
    subheader: 'general',
    items: [
      {
        title: 'Home',
        path: HomePagesRoutes.productApprovalOperaterHomePage,
        icon: ICONS.dashboard,
      },
    ],
  },
  {
    subheader: 'E-Fiscal',
    items: [
      {
        title: 'Verifikacija proizvoda',
        path: ProductMatchIndex,
        icon: ICONS.file,
      },
      {
        title: 'Unos naziva proizvoda',
        path: EnterProductNames,
        icon: ICONS.folder,
      },
    ],
  },
];
